import React from "react";
const DownloadIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.5 20c.276 0 .5.224.5.5s-.224.5-.5.5h-12c-.276 0-.5-.224-.5-.5s.224-.5.5-.5h12zm-6-16c.276 0 .5.224.5.5v11.515l2.197-1.898c.2-.173.503-.151.677.049l.009.01.005.007c.17.21.144.517-.06.694l-2.978 2.574c-.048.042-.103.072-.16.092-.165.089-.375.075-.53-.051l-.01-.009-2.977-2.573c-.205-.177-.231-.485-.06-.694l.005-.007c.167-.205.47-.236.675-.069l.01.01L11 16.047V4.5c0-.276.224-.5.5-.5z"
  }
));
var downloadIcon_default = DownloadIcon;
export {
  downloadIcon_default as default
};
//# sourceMappingURL=downloadIcon.js.map
